export default __webpack_public_path__ + "static/media/lock.a306caa3.svg";